import {
  sequence_repository,
  task_repository,
} from '@/repositories';

const state = () => ({
  task_type_list: [],
});

const getters = {
  taskTypeList: (state) => state.task_type_list,
};

const mutations = {
  set_task_type_list(state, task_type_list) {
    state.task_type_list = task_type_list;
  },
};

const actions = {
  createTaskForSequence(_, {sequence_id, step}) {
    return sequence_repository
      .createStep(sequence_id, step);
  },
  getTaskTypes({ commit }) {
    return task_repository
      .getTaskTypes()
      .then((response) => {
        const {
          task_type_list,
        } = response;

        commit('set_task_type_list', task_type_list);

        return task_type_list;
      });
  },
  async createTaskType({ dispatch }, input) {
    const created_task_type = await task_repository.createTaskType(input);

    dispatch('getTaskTypes');

    return created_task_type;
  },
  async updateTaskType({ dispatch }, { task_type_id, input }) {
    const updated_task_type = await task_repository.updateTaskType(task_type_id, input);

    dispatch('getTaskTypes');

    return updated_task_type;
  },
  async deleteTaskType({ dispatch }, task_type_id) {
    const result = await task_repository.deleteTaskType(task_type_id);

    dispatch('getTaskTypes');

    return result;
  },
  async createTask(_, input) {
    const created_task = await task_repository.createTask(input);

    return created_task;
  },
  async bulkCreateTasks(_, input) {
    const result = await task_repository.bulkCreateTasks(input);

    return result;
  },
  async updateTask(_, { task_id, input }) {
    const updated_task = await task_repository.updateTask(task_id, input);

    return updated_task;
  },
};

export default {
  actions,
  getters,
  mutations,
  namespaced: true,
  state,
};
